import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { HELP } from 'constants/shared/routes';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import ZendeskFAQsItem from '../presentational/ZendeskFAQsItem';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import useTranslate from 'lib/languages/useTranslate';
import { selectCurrentLanguage } from 'lib/slices';
import {
    useGetZendeskArticlesQuery,
    useGetZendeskCategoriesQuery,
} from 'lib/services';

const ZendeskFAQsItemContainer = () => {
    const { id } = useParams() as { id: string };
    const language = useSelector(selectCurrentLanguage);
    const translate = useTranslate('faqs');

    const { data: articles, error, isFetching } = useGetZendeskArticlesQuery(
        { categoryId: id, language },
        { skip: !language },
    );

    const { data: categoryName } = useGetZendeskCategoriesQuery(language, {
        skip: !language,
        selectFromResult: ({ data }) => ({
            data: data?.find(cat => cat.id === Number(id))?.name,
        }),
    });

    return (
        <PageContainer className="help-container">
            <SectionTitle
                title={`Help - ${categoryName || ''}`}
                backRoute={HELP}
            />
            <DataCheck
                noDataMessage={translate('noDataMessage')}
                data={articles}
                isLoading={isFetching}
                error={error}
            >
                <ZendeskFAQsItem faqs={articles} />
            </DataCheck>
        </PageContainer>
    );
};

export default ZendeskFAQsItemContainer;
